
<template>
  <div class="row">



    <div>
      <h4>Wystawienie dokumentów wypłat</h4>
      <p>Dokumenty wypłat zostaną pogrupowane zgodnie z dostawcą i odpowiednią apteką.</p>
      <p>Po wygenerowaniu będzie możliwy ich wydruk lub eksport.</p>

      <ScrollableListView :title=documentsListHeader :listContent="paymentDocumentNumbersJoinStr"></ScrollableListView>


    </div>
    <div v-if="showConfirmationButton">
      <button type="button" class="btn btn-primary" @click="confirmPayment">Potwierdź</button>
    </div>



  </div>

</template>


<script>
import ScrollableListView from "@/components/widgets/ScrollableListView.vue";
import {log} from "@/state/pinia/log";

export default {
  name: "PaymentDocumentCreationConfirmationModal",
  components: { ScrollableListView},
  props: {
    documentsRequests: Array,
    showConfirmationButton: Boolean
  },
  emits: ["onPaymentConfirmed"],
  data() {
    return {
      documentsToCreatePaymentDoc: this.documentsRequests,
    };
  },
  computed: {
    documentsListHeader() {
      return "Opłacone dokumenty zakupu, do których zostaną wystawione dokumenty wypłat (" + this.documentsToCreatePaymentDoc.length + "):";
    },
    paymentDocumentNumbersJoinStr() {
      log.log("this.documentsToCreatePaymentDoc");
      log.log(this.documentsToCreatePaymentDoc);
      if(this.documentsToCreatePaymentDoc == null){
        return "";
      }
      var docNumbers = this.documentsToCreatePaymentDoc.map(doc => doc.documentNumber);
      return docNumbers.join(";");
    },


  },
  methods: {
    confirmPayment() {
      this.$emit("onPaymentConfirmed");
    },
  },
  watch: {},
  created() {
  }
};

</script>
<style scoped>

</style>
